import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ModalPopupComponent } from "src/app/shared/components/ui/modal-popup.component";
import { TableComponent } from "src/app/shared/components/ui/table/table.component";
import { Order, OrderEmail } from "src/app/shared/models/order.model";
import { EditOrderEmailComponent } from "./edit-order-email/edit-order-email.component";

@Component({
  selector: "order-emails",
  standalone: true,
  imports: [
    TableComponent,
    TranslateModule,
    CommonModule,
    ModalPopupComponent,
    EditOrderEmailComponent,
  ],
  templateUrl: "./order-emails.component.html",
  styleUrl: "./order-emails.component.scss",
})
export class OrderEmailsComponent {
  @Input() order: Order;
  @Output() onUpdEmail = new EventEmitter();

  selectedEmail?: OrderEmail;
  displayEdit: boolean = false;

  createEmail() {
    this.selectedEmail = new OrderEmail();
    this.selectedEmail.status = "NEW";
    this.displayEdit = true;
  }

  onRowSelect(email: OrderEmail) {
    this.selectedEmail = email;
    this.displayEdit = true;
  }

  onSaveEmail() {
    this.displayEdit = false;
    this.onUpdEmail.emit();
  }
}
